import React, {Component} from 'react';
import {Modal,List,Button} from 'antd-mobile';
import "./style.less";
import moment from 'moment';
const tobeselected = require('../../common/image/tobeselected.png');
const selected = require('../../common/image/selected.png');
export default class SeatSelect extends Component {
    constructor(props) {
        super(props);
        console.log(this.props);
        this.state = {
            seatId:'',
            showModalIndex:-1,//默认-1  不弹出modal
            buy:'',
            res:{},
            owner:'',
            status:'',
            isChild:0,
        };

        this.renderModal = this.renderModal.bind(this);
        this.onClose = this.onClose.bind(this);
    }
    componentDidMount() {
    }
    onClose(index){
        this.setState({
            showModalIndex:-1
        });
    }
    modalWinow(res){
        var index = -1;
        if(res.status == 2 || res.status == 3 || res.status == 5){
            index = 0; 
        }else if(res.status == 1){
            index = 1;
        }
        else if(res.status == 12 || res.status == 13 || res.status == 14 || res.status == 15){
            index = 2;
        }
        else if(res.status == 16 || res.status == 17 || res.status == 11){
            index = 3;
        }
        // else if(res.status == 4){
        //     index = 4;
        // }
        this.setState({
            showModalIndex:index,
            seatId:res.id,
            res:res,
            owner:res.owner,
            status:res.status,
            isChild:res.isChild
        });
    }
    
    // 选择性弹出modal
    renderModal(){
        var modals = [];
        modals.push(
            <Modal
                popup
                key={1}
                closable
                visible={this.state.showModalIndex == 0}
                animationType="slide-up"
                maskClosable={true}
                onClose={this.onClose.bind(this,0)}
            >
                <div className="btnBox">
                    <div className="jiesuo" onClick={() => {this.props.unlockSeat(this.state.seatId);setTimeout(() => {this.setState({showModalIndex:-1})}, 1000);}}>解锁</div>
                </div>
            </Modal>
        );
        modals.push(
            <Modal
                popup
                key={2}
                closable
                visible={this.state.showModalIndex == 1}
                animationType="slide-up"
                maskClosable={true}
                onClose={this.onClose.bind(this,1)}
            > 
                <div className="btnBox">
                    <div className="lockSeat"  onClick={() => {this.props.lockSeat(this.state.seatId);setTimeout(() => {this.setState({showModalIndex:-1})}, 1000);}}>锁定</div>
                    {this.props.buyFlag == 1 && (this.props.timestamp < this.props.startCurrentTimeMillis) ? <div className="buyTicket"  onClick={() => this.props.goPage('addPassengers',this.state.res,this.state.seatId)}>下单</div>: null}
                </div>
               
            </Modal>
        );
        modals.push(
            <Modal
                popup
                key={3}
                closable
                visible={this.state.showModalIndex == 2}
                animationType="slide-up"
                maskClosable={true}
                onClose={this.onClose.bind(this,2)}
            >
                <div className="btnBox" >
                    <div className="seatDetail" onClick={() => this.props.goPage('passengerInfo',this.state.res,this.state.seatId)}>查看详情</div>
                    {this.state.owner == 1 &&  (this.props.timestamp < this.props.startCurrentTimeMillis) ? <div className="lockSeat" onClick={() => this.props.goPage('refundTicket',this.state.res,this.state.seatId)}>退票</div> : null}
                    {this.state.owner == 1 && this.state.isChild == 0 &&  (this.props.timestamp < this.props.startCurrentTimeMillis) ? <div className="change" onClick={() => this.props.goPage('SelectShift',this.state.res,this.state.seatId)}>改签</div> : null}
                    {this.props.specialRefund == 1 && this.state.isChild == 0 && (this.props.timestamp < this.props.startCurrentTimeMillis) ? <div className="specialChange" onClick={() => this.props.goPage('SelectShift',this.state.res,this.state.seatId,'special')}>特殊改签</div> : null}
                </div>
          </Modal>
        );
        modals.push(
            <Modal
                key={4}
                popup
                closable
                visible={this.state.showModalIndex == 3}
                animationType="slide-up"
                maskClosable={true}
                onClose={this.onClose.bind(this,3)}
            >
                <div className="btnBox">
                    <div className="seatDetail" onClick={() => this.props.goPage('passengerInfo',this.state.res,this.state.seatId)}>查看详情</div>
                </div>
            </Modal>
        );
        modals.push(
            <Modal
                popup
                key={5}
                closable
                visible={this.state.showModalIndex == 4}
                animationType="slide-up"
                maskClosable={true}
                onClose={this.onClose.bind(this,4)}
            >
                <div className="btnBox">
                    <div className="wordtip">已有乘客正在支付中！</div>
                    <div className="waitTip">请稍后再进行此操作</div>
                    <div className="buyTicket" onClick={this.onClose.bind(this,4)}>知道了</div>
                </div>
            </Modal>
        );
       
        return modals;
    }

    render() {
        return (
            <div className="seatsModal">
                <div className="seatInfo">
                    <div className="wordInfo">出行位置信息</div>
                    <div className="header">
                        <div><span className="kexuan"/>未购</div>
                        <div><span className="xuanze"/>已购</div>
                        <div><span className="buy"/>锁定</div>
                    </div>
                </div>
                <div className="seatBox">
                    { 
                        this.props.seatData.map((res, i) => (
                            <div  
                                key={i}
                                className={this.props.check(res)}
                                id="div"
                                onClick={() => this.modalWinow(res)}
                            >
                                   <div className="selectSeat">
                                        <img src={res.status == 1 || res.status == 2 || res.status == 3 || res.status == 4 || res.status == 5  ? tobeselected:selected }/>
                                        <span>{res.seatNum}号</span>
                                        {res.isChild === 1 ? <span className="child">儿童订单</span> : null}
                                        
                                    </div>
                                    {res.status == 1 || res.status == 2 || res.status == 3 || res.status == 4 || res.status == 5 ? <span className="unsell">暂未购买</span> :<span className="cityRound">{res.startCity} — {res.endCity}</span>}
                                    {this.props.status(res)}
                            </div>
                    
                        ))
                    }
                </div>
                {this.renderModal()}    
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/SeatSelModal/index.js